import { Pencil } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "~/components/ui";
import { Dialog } from "./Dialog";

export default function FormFieldDialog({
  children,
  title,
  description,
  width = "98ww",
  trigger,
}: {
  children: React.ReactNode;
  title?: string;
  description?: string;
  width?: string;
  trigger?: React.ReactNode;
}) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <Dialog
      title={title ?? t("common.edit")}
      description={description ?? t("common.edit")}
      width={width}
      maxWidth="95vw"
      open={open}
      onOpenChange={setOpen}
      trigger={
        trigger ?? (
          <Button variant="outline" type="button">
            <Pencil className="h-[1.2rem] w-[1.2rem]" />
            {t("common.edit")}
          </Button>
        )
      }
    >
      {children}
    </Dialog>
  );
}
